import { api } from "./client";

const BASE = "/modules/ap-workbench";

export const apWorkbenchApi = {
  listInvoices: (params = {}) =>
    api.get(`${BASE}/invoices`, { params }).then((r) => r.data),

  counts: () =>
    api.get(`${BASE}/invoices/counts`).then((r) => r.data.counts),

  getInvoice: (id) =>
    api.get(`${BASE}/invoices/${id}`).then((r) => r.data.invoice),

  getImages: (id) =>
    api.get(`${BASE}/invoices/${id}/images`).then((r) => r.data.images),

  resolveLine: (invoiceId, lineId, body) =>
    api
      .patch(`${BASE}/invoices/${invoiceId}/lines/${lineId}`, body)
      .then((r) => r.data.invoice),

  unresolveLine: (invoiceId, lineId) =>
    api
      .post(`${BASE}/invoices/${invoiceId}/lines/${lineId}/unresolve`)
      .then((r) => r.data.invoice),

  refreshDenorm: (id) =>
    api
      .post(`${BASE}/invoices/${id}/refresh-denorm`)
      .then((r) => r.data.invoice),

  markReady: (id) =>
    api.post(`${BASE}/invoices/${id}/mark-ready`).then((r) => r.data.invoice),

  unmarkReady: (id) =>
    api
      .post(`${BASE}/invoices/${id}/unmark-ready`)
      .then((r) => r.data.invoice),

  // Admin-only. Hard-deletes the invoice (and its lines, via CASCADE).
  deleteInvoice: (id) =>
    api.delete(`${BASE}/invoices/${id}`).then((r) => r.data),

  // Admin-only. Bulk-deletes every invoice currently in the
  // pending-resolution tab. `confirm` must be the literal string "DELETE".
  deletePendingResolution: (confirm) =>
    api
      .delete(`${BASE}/invoices/pending`, { data: { confirm } })
      .then((r) => r.data),
};
